import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=e5421622&scoped=true&"
var script = {}
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=e5421622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5421622",
  null
  
)

export default component.exports